export default __webpack_public_path__ + "df5a6b700f75c8f6ab03421e944162ab.svg";